/* tooltip-primitive.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./tooltip-primitive.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { forwardRef } from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { TooltipShortcut } from './tooltip-shortcut';
var primitiveStyles = null;

/**
 * The lower level component for rendering a tooltip.
 */
var TooltipPrimitive = /*#__PURE__*/forwardRef(function TooltipPrimitive(_ref, ref) {
  var style = _ref.style,
    className = _ref.className,
    children = _ref.children,
    placement = _ref.placement,
    testId = _ref.testId,
    onMouseOut = _ref.onMouseOut,
    onMouseOver = _ref.onMouseOver,
    id = _ref.id,
    shortcut = _ref.shortcut;
  return /*#__PURE__*/React.createElement("div", {
    ref: ref
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    ,
    style: style,
    "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
  }, /*#__PURE__*/React.createElement("div", {
    role: "tooltip"
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ,
    className: ax(["_80om73ad", className])
    // Because the tooltip should not be focusable, there is no reason to have key events.
    /* eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events */,
    onMouseOut: onMouseOut
    /* eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events */,
    onMouseOver: onMouseOver,
    "data-placement": placement,
    "data-testid": testId,
    id: id
  }, children, shortcut && fg('platform-dst-tooltip-shortcuts') && /*#__PURE__*/React.createElement(TooltipShortcut, {
    shortcut: shortcut
  })));
});
TooltipPrimitive.displayName = 'TooltipPrimitive';
export default TooltipPrimitive;